export default __webpack_public_path__ + "static/media/onboarding-step-2.43b85195.png";